import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import useMount from '@/hooks/useMount';

const useOnRouteChange = (onChange) => {
  const initialLocation = useLocation();
  const { listen } = useHistory();

  const [location, setLocation] = useState(() => initialLocation);

  useMount(() => {
    const unsubscribe = listen((location) => {
      setLocation(location);
      onChange(location);
    });

    return () => {
      unsubscribe();
    };
  });

  return location;
};

export default useOnRouteChange;
